import React from "react";

const style: React.CSSProperties = {
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

/**
 * Short table values (timestamps, aliases, event labels, counts) stay on one line even in a
 * `wrapLines` table: ellipsis at the column edge, the full value on hover.
 */
export const OneLine: React.FC<{
  children: React.ReactNode;
  /** Hover text; defaults to the children when they are plain text. */
  title?: string;
}> = ({ children, title }) => (
  <span
    style={style}
    title={
      title ??
      (typeof children === "string" || typeof children === "number"
        ? String(children)
        : undefined)
    }
  >
    {children}
  </span>
);
